import { Box } from '@mui/material';
import { OutfitItem } from '@/components/blocks/ModalOutfits/parts/OutfitItem';
import { useModalOutfitsContext } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';

export const OutfitList = () => {
	const { products } = useModalOutfitsContext();

	return (
		<Box>
			{products.map((product) => (
				<OutfitItem key={product.id} product={product} />
			))}
		</Box>
	);
};
